function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { theme } from '@arc/frontend/ui-theme';
import { ListPageSelector, ListPaginationTotal } from './ListPagination';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "w1sy6r",
    styles: "display:flex;justify-content:space-between;padding-left:1rem;padding-right:1rem;padding-top:0.5rem;padding-bottom:0.5rem;flex-direction:column;align-items:flex-start;height:80px"
  } : {
    name: "yzblwn-container",
    styles: "display:flex;justify-content:space-between;padding-left:1rem;padding-right:1rem;padding-top:0.5rem;padding-bottom:0.5rem;flex-direction:column;align-items:flex-start;height:80px;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  buttonsWrap: process.env.NODE_ENV === "production" ? {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
  } : {
    name: "1fsnsbu-buttonsWrap",
    styles: "display:flex;align-items:center;label:buttonsWrap;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  text: /*#__PURE__*/css({
    color: theme.colors.text.primary,
    fontWeight: '400'
  }, process.env.NODE_ENV === "production" ? "" : ";label:text;"),
  dropDownBtnOptionsWrap: process.env.NODE_ENV === "production" ? {
    name: "1by8trd",
    styles: "position:relative;margin-left:1rem"
  } : {
    name: "1n1vsq1-dropDownBtnOptionsWrap",
    styles: "position:relative;margin-left:1rem;label:dropDownBtnOptionsWrap;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  dropdownBtn: /*#__PURE__*/css({
    backgroundColor: theme.colors.background.paper,
    borderColor: theme.colors.input.border,
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    borderWidth: '1px',
    display: 'flex',
    alignItems: 'center',
    outline: '2px solid transparent',
    outlineOffset: '2px',
    ':focus': {
      outline: '2px solid transparent',
      outlineOffset: '2px'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:dropdownBtn;"),
  dropdownList: process.env.NODE_ENV === "production" ? {
    name: "wqnph7",
    styles: "box-shadow:0px 4px 8px #0000001f;position:absolute;bottom:0px;left:0px;right:0px;outline:2px solid transparent;outline-offset:2px"
  } : {
    name: "1siop9n-dropdownList",
    styles: "box-shadow:0px 4px 8px #0000001f;position:absolute;bottom:0px;left:0px;right:0px;outline:2px solid transparent;outline-offset:2px;label:dropdownList;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  openList: /*#__PURE__*/css({
    borderColor: theme.colors.input.border,
    borderWidth: '1px',
    outline: '2px solid transparent',
    outlineOffset: '2px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:openList;"),
  dropdownOption: process.env.NODE_ENV === "production" ? {
    name: "1kw2t2i",
    styles: "padding:0.5rem;text-align:left"
  } : {
    name: "1ya2bgi-dropdownOption",
    styles: "padding:0.5rem;text-align:left;label:dropdownOption;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export function SidebarPagination({
  rowsPerPage,
  totalItems,
  page,
  onChangePage,
  itemType,
  isLoading
}) {
  return <div css={styles.container}>
			{isLoading ? null : <>
					<div css={styles.buttonsWrap}>
						<ListPaginationTotal totalItems={totalItems} itemType={itemType} sidebarView />
					</div>
					<ListPageSelector totalItems={totalItems} rowsPerPage={rowsPerPage} page={page} onChangePage={onChangePage} delta={0} />
				</>}
		</div>;
}